<template>
<div class="content-wrappper">
  <router-view v-if="roleId" :roleId="roleId" :account_id="account_id" :userId="userId" :account_type_id="account_type_id"></router-view>
</div>
</template>

<script>
export default {
  props: {
    account_id: Number,
    roleId: Number,
    userId: Number,
    isDashboardNotification: Object,
    isDashboardCustomizable: Boolean,
    isDefault: Boolean,
    account_type_id: Number,
  },
  data() {
    return {
      key: '',
    };
  },
};
</script>

<style scoped>

</style>
